export default __webpack_public_path__ + "static/media/litho-landing-page-img-05.110d2c9e.jpg";